/**
 * @param promises - Each argument is a promise chained one after the other
 * @return Returns a function that triggers the chain
 */
export function composePromises(...promises) {
  return (value) => promises.reduce((promiseChain, promise) => promiseChain.then(promise), Promise.resolve(value))
}
